import { Box } from '@mui/material';
import { Flow } from '@lendica/components';

export const Layout = ({ children, loading, maxWidth = 900, ...props }) => {
    return (
        <Box
            sx={{
                height: 'fit-content',
                minHeight: '100vh',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                paddingTop: '1.5rem',
                paddingBottom: '3rem',
                boxSizing: 'border-box',
                backgroundColor: 'background.paper',
                ...props.sx,
            }}
            {...props}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    maxWidth: maxWidth,
                    justifyContent: 'center',
                }}
            >
                {loading ? <Flow /> : children}
            </Box>
        </Box>
    );
};
